import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import { appContext } from '../../../../../app.context';

class DatiDDTPRModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$uibModal',
        '$sce'
    ];

    private close: any;
    private settings: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $sce: ng.ISCEService
    ) {
        /* tslint:disable:no-string-literal */
        // dettaglioLinee:
        this.settings = $scope.$parent.$resolve.settings;
        $scope.datiDDTTooltip = $sce.trustAsHtml(
            'Questa sezione non è obbligatoria, ma potrebbe essere molto importante per il tuo cliente. Qui puoi inserire i dati di riferimento del Documento di Trasporto con il quale è stata spedita la merce. Questo aiuterà il destinatario ad integrare il ciclo passivo di fatturazione.');

        $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');

        let itemTemplate = {
            'NumeroDDT': '',
            'RiferimentoNumeroLinea': [],
            'DataDDT': ''
        };
        $scope.dettaglioLinee = this.settings.dettaglioLinee;
        $scope.items = [];

        let extractModalItems = (inputItems, label) => {
            if (inputItems === undefined) {
                return [];
            }
            let outputItems = [];
            for (let i = 0; i < inputItems.length; i++) {
                let item = jQuery.extend(true, {}, itemTemplate);
                //                        item.TipoDocumento = label;

                for (let j = 0; j < this.settings.dettaglioLinee.length; j++) {
                    if (inputItems[i].RiferimentoNumeroLinea.indexOf(this.settings.dettaglioLinee[j].NumeroLinea * 1) !== -1) {
                        item.RiferimentoNumeroLinea.push(true);
                    } else {
                        item.RiferimentoNumeroLinea.push(false);
                    }
                }

                item.NumeroDDT = inputItems[i].NumeroDDT;
                item.DataDDT = inputItems[i].DataDDT;

                outputItems.push(item);
            }
            return outputItems;
        };
        let extractFatturaItems = () => {
            let DatiGenerali: any = {};
            DatiGenerali.DatiDDT = [];

            for (let i = 0; i < $scope.items.length; i++) {

                let newItem = jQuery.extend(true, {}, itemTemplate);

                for (let j = 0; j < this.settings.dettaglioLinee.length; j++) {
                    if ($scope.items[i].RiferimentoNumeroLinea[j] === true) {
                        newItem.RiferimentoNumeroLinea.push(this.settings.dettaglioLinee[j].NumeroLinea * 1);
                    }
                }

                newItem.NumeroDDT = $scope.items[i].NumeroDDT;
                newItem.DataDDT = $scope.items[i].DataDDT;

                DatiGenerali['DatiDDT'].push(newItem);
            }

            return DatiGenerali;
        };

        $scope.items = $scope.items.concat(extractModalItems(this.settings.datiGenerali.DatiDDT, 'DatiDDT'));

        $scope.addItem = () => {
            $scope.items.push(jQuery.extend(true, {}, itemTemplate));
        };
        $scope.removeItem = (index) => {
            let modalInstance = $uibModal.open({
                animation: $scope.animationsEnabled,
                component: 'defaultModalComponent',
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    config: () => {
                        return {
                            headerIcon: 'fa fa-exclamation-triangle',
                            headerText: 'Attenzione',
                            bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare Dati DDT?',
                            buttons: [
                                {
                                    'id': 1,
                                    'icon': 'fa fa-ban',
                                    'label': 'Annulla'
                                },
                                {
                                    'id': 2,
                                    'icon': 'fa fa-check-circle-o',
                                    'label': 'Si'
                                }
                            ]
                        };
                    }
                }
            });
            modalInstance.result.then((pressedButtonId) => {
                if (pressedButtonId !== undefined) {
                    if (pressedButtonId === 1) {
                        // ??
                    }
                    if (pressedButtonId === 2) {
                        $scope.items.splice(index, 1);
                    }
                }
            }, () => {
                // ?
            });
        };
        $scope.save = (errors) => {
            if ($.isEmptyObject(errors)) {
                let DatiGenerali = extractFatturaItems();
                this.close({ $value: DatiGenerali });
            } else {
                $rootScope.setErrorFieldsTouched(errors);
                $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
            }
        };

        $scope.cancel = () => {
            this.close();
        };

        $scope.dpOpened = {
            //                    dataDDT: false,
        };

        $scope.calendar = {
            opened: {},
            dateFormat: 'dd/MM/yyyy',
            dateOptions: {},
            open: ($event, which, index) => {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.calendar.opened[which] = [];
                $scope.calendar.opened[which][index] = true;
            }
        };

        $scope.autoOpen = {
            opened: {},
            dateFormat: 'dd/MM/yyyy',
            dateOptions: {},
            open: ($event, which, index) => {

                if (appContext.userBrowser['isIE']) {
                    return;
                }

                $event.preventDefault();
                $event.stopPropagation();
                $scope.calendar.opened[which] = [];
                $scope.calendar.opened[which][index] = true;
            }
        };
    }
}

export const DatiDDTPRModalComponent: ng.IComponentOptions = {
    template: require('./dati-ddt-pr-modal.html'),
    controller: DatiDDTPRModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dati-ddt-pr-modal/dati-ddt-pr-modal.ts